var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 54.586,
    viewBox: "0 0 56 54.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-4 -4.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M27.586,20l2-2H18.414l2,2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M56,18.414,54.414,20H56Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M28.586,38l-.008-.008L28.566,38Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M18.293,22.293l1.414,1.414L18.414,25,20,26.586l1.293-1.293,1.414,1.414L21.414,28,23,29.586l1.293-1.293,1.414,1.414L24.414,31,26,32.586l1.293-1.293,1.414,1.414L27.414,34,29,35.586l1.293-1.293,1.414,1.414L30.414,37l1,1h4.172L8,10.414,5.914,12.5,17,23.586Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M22.414,22,24,23.586,25.586,22",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M47.414,38H56V36.414L52.586,33H51.271a2.76,2.76,0,0,1-2.622-1.89l-.086-.259-1.712,1.712.26.087a2.762,2.762,0,0,1,1.079,4.574Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 2.243,
    height: 6.485,
    transform: "translate(43.414 12.999) rotate(-45)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M56.586,15l-2-2H52a1,1,0,0,1-.707-.293l-4-4A1,1,0,0,1,47,8V5.414l-1-1L37.414,13,48,23.586ZM41.293,13.707a1,1,0,0,1,0-1.414l3-3a1,1,0,0,1,1.414,0l6,6a1,1,0,0,1,0,1.414l-3,3a1,1,0,0,1-1.414,0Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 3.657,
    height: 2.243,
    transform: "translate(43.414 30.001) rotate(-45)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M33.232,32.818l11.589-7.054.472-.471a.987.987,0,0,1,.766-.282l.335-.2L36,14.414,25.414,25ZM6,21V15.414L4.656,14.07A.993.993,0,0,0,4,15V38H6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(7 43)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M8,18v2h2.586l-2-2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M45,40H4V59H60V40ZM5,44a3,3,0,1,1,3,3A3,3,0,0,1,5,44Zm51.625,8.781-5,4A1,1,0,0,1,51,57H45a1,1,0,0,1-.707-.293l-1.026-1.026A5.7,5.7,0,0,0,39.209,54H13a4,4,0,0,1,0-8H38.4a5.724,5.724,0,0,0,4.773-2.555A1,1,0,0,1,44,43h5a1,1,0,0,1,.707.293l4,4A1,1,0,0,1,53,49H49.281l.5,2H56a1,1,0,0,1,.625,1.781Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M48.03,52.242l-1-4A1,1,0,0,1,48,47h2.586l-2-2H44.512A7.719,7.719,0,0,1,38.4,48H13a2,2,0,0,0,0,4H39.209a7.687,7.687,0,0,1,5.472,2.267l.733.733h5.235l2.5-2H49A1,1,0,0,1,48.03,52.242Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M24.719,38l2.4-1.463L20.5,29.914,18.414,32l6,6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M14,36.414,12.414,38h3.172Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M58.414,14l.293.293a1,1,0,0,1,0,1.414L58,16.414V38h2V14Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M21.586,38l-10-10H10v1.586L18.414,38Z",
    fill: "#444"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiy);
export default __webpack_public_path__ + "static/media/diy.d6f3a36aea6bdf06ad202cd5d11f9b83.svg";
export { ForwardRef as ReactComponent };